module.exports = __webpack_public_path__ + "media/images/iconSearch-53fc02efd7391bb48e6902438bf6afc9.png";